__turbopack_context__.v({
  "element": "stylesSK-module-scss-module__qQ5lHG__element",
  "fbutton": "stylesSK-module-scss-module__qQ5lHG__fbutton",
  "footer": "stylesSK-module-scss-module__qQ5lHG__footer",
  "formWrapper": "stylesSK-module-scss-module__qQ5lHG__formWrapper",
  "hppWrapper": "stylesSK-module-scss-module__qQ5lHG__hppWrapper",
  "hprojectsContainer": "stylesSK-module-scss-module__qQ5lHG__hprojectsContainer",
  "hprojectsWrapper": "stylesSK-module-scss-module__qQ5lHG__hprojectsWrapper",
  "htext": "stylesSK-module-scss-module__qQ5lHG__htext",
  "htitle": "stylesSK-module-scss-module__qQ5lHG__htitle",
  "input": "stylesSK-module-scss-module__qQ5lHG__input",
  "inputWrapper": "stylesSK-module-scss-module__qQ5lHG__inputWrapper",
  "link": "stylesSK-module-scss-module__qQ5lHG__link",
  "navContainer": "stylesSK-module-scss-module__qQ5lHG__navContainer",
  "ppContainer": "stylesSK-module-scss-module__qQ5lHG__ppContainer",
  "ppFlip": "stylesSK-module-scss-module__qQ5lHG__ppFlip",
  "ppInfo": "stylesSK-module-scss-module__qQ5lHG__ppInfo",
  "ppWrapper": "stylesSK-module-scss-module__qQ5lHG__ppWrapper",
  "projectCard": "stylesSK-module-scss-module__qQ5lHG__projectCard",
  "projectsContainer": "stylesSK-module-scss-module__qQ5lHG__projectsContainer",
  "projectsWrapper": "stylesSK-module-scss-module__qQ5lHG__projectsWrapper",
  "secTitleWrapper": "stylesSK-module-scss-module__qQ5lHG__secTitleWrapper",
  "shimmer": "stylesSK-module-scss-module__qQ5lHG__shimmer",
  "skills": "stylesSK-module-scss-module__qQ5lHG__skills",
  "skillsWrapper": "stylesSK-module-scss-module__qQ5lHG__skillsWrapper",
  "social": "stylesSK-module-scss-module__qQ5lHG__social",
  "socialWrapper": "stylesSK-module-scss-module__qQ5lHG__socialWrapper",
  "spContainer": "stylesSK-module-scss-module__qQ5lHG__spContainer",
  "subtit": "stylesSK-module-scss-module__qQ5lHG__subtit",
  "text": "stylesSK-module-scss-module__qQ5lHG__text",
  "textWrapper": "stylesSK-module-scss-module__qQ5lHG__textWrapper",
  "textarea": "stylesSK-module-scss-module__qQ5lHG__textarea",
  "titleh1": "stylesSK-module-scss-module__qQ5lHG__titleh1",
  "titleh3": "stylesSK-module-scss-module__qQ5lHG__titleh3",
  "titleh4": "stylesSK-module-scss-module__qQ5lHG__titleh4",
});
